module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "test1"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }]
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "close"
    },
    on: {
      "click": function($event) {
        _vm.detailDisp = !_vm.detailDisp
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.detail) + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descCodapprDisp),
      expression: "descCodapprDisp"
    }]
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "close"
    },
    on: {
      "click": function($event) {
        _vm.descCodapprDisp = !_vm.descCodapprDisp
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.descCodappr) + "\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descCodempapDisp),
      expression: "descCodempapDisp"
    }]
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "close"
    },
    on: {
      "click": function($event) {
        _vm.descCodempapDisp = !_vm.descCodempapDisp
      }
    }
  }), _vm._v("\n    " + _vm._s(_vm.descCodempap) + "\n  ")]), _vm._v(" "), _vm._l((_vm.selected), function(val, key) {
    return _c('div', [_vm._v("\n    " + _vm._s(key) + " : " + _vm._s(val) + "\n  ")])
  }), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data,
      "page": 1,
      "limit": 10,
      "indexDisp": _vm.indexDisp,
      "multiSelect": _vm.multiSelect,
      "maxRowspan": _vm.maxRowspan,
      "columnEvent": _vm.columnEvent,
      "staapprDisp": _vm.staapprDisp,
      "detailDisp": true,
      "detailEvent": _vm.detailEvent
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b413c334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/test1/component.vue
// module id = 3957
// module chunks = 1